import { apiClient } from './client';

export interface APIUserProfile {
  userId: string;
  email: string;
  username?: string;
  xp: number;
  level: number;
  createdAt: string;
  lastActive: string;
  stats?: {
    totalChallengesCompleted: number;
    totalLevelsCompleted: number;
    totalAchievements: number;
    averageStars: number;
  };
}

export interface APIUserSettings {
  theme: 'light' | 'dark';
  soundEnabled: boolean;
  musicEnabled: boolean;
  animationsEnabled: boolean;
}

export interface UpdateProfileRequest {
  username?: string;
  avatar?: string;
}

export interface AddXPRequest {
  amount: number;
  source?: string;
  sourceId?: string;
}

export interface AddXPResponse {
  userId: string;
  xp: number;
  level: number;
  leveledUp: boolean;
  nextLevelXP: number;
}

export const usersApi = {
  async getProfile(userId: string): Promise<APIUserProfile> {
    return apiClient.get(`/users/${userId}/profile`);
  },

  async updateProfile(userId: string, updates: UpdateProfileRequest): Promise<APIUserProfile> {
    return apiClient.put(`/users/${userId}/profile`, updates);
  },

  async addXP(userId: string, request: AddXPRequest): Promise<AddXPResponse> {
    return apiClient.patch(`/users/${userId}/xp`, request);
  },

  async getSettings(userId: string): Promise<APIUserSettings> {
    return apiClient.get(`/users/${userId}/settings`);
  },

  async updateSettings(userId: string, settings: Partial<APIUserSettings>): Promise<APIUserSettings> {
    return apiClient.put(`/users/${userId}/settings`, settings);
  },
};
